import React from 'react';
import PropTypes from 'prop-types';
import { StaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import User from '../../../../../icons/svg/User';

const UserIcon = ({ author, emoji }) => (
  <StaticQuery
    query=
      {graphql`
        query {
          star: file(relativePath: { eq: "user-icon-new.png" }) {
            childImageSharp {
              fixed(width: 32) {
                ...GatsbyImageSharpFixed
              }
            }
          }
          smiley: file(relativePath: { eq: "star-1.png.png" }) {
            childImageSharp {
              fixed(width: 32) {
                ...GatsbyImageSharpFixed
              }
            }
          }
          crazy: file(relativePath: { eq: "star-2.png" }) {
            childImageSharp {
              fixed(width: 32) {
                ...GatsbyImageSharpFixed
              }
            }
          }
          cowboy: file(relativePath: { eq: "star-3.png" }) {
            childImageSharp {
              fixed(width: 32) {
                ...GatsbyImageSharpFixed
              }
            }
          }
          devil: file(relativePath: { eq: "star-4.png" }) {
            childImageSharp {
              fixed(width: 32) {
                ...GatsbyImageSharpFixed
              }
            }
          }
          love: file(relativePath: { eq: "star-5.png" }) {
            childImageSharp {
              fixed(width: 32) {
                ...GatsbyImageSharpFixed
              }
            }
          }
        }
      `}
    render={data => {
      let emojiObject;
      switch (emoji) {
        case 'love':
          emojiObject = data.love;
          break;
        case 'devil':
          emojiObject = data.devil;
          break;
        case 'cowboy':
          emojiObject = data.cowboy;
          break;
        case 'crazy':
          emojiObject = data.crazy;
          break;
        case 'smiley':
          emojiObject = data.crazy;
          break;
        default:
          emojiObject = null;
      }
      return (
        <div className="star-holder">
          {(emoji && emojiObject) ? <div className="emoji-wrap"><Img alt={author} fixed={emojiObject.childImageSharp.fixed}/></div>
            : <User idA={author.toLowerCase() + Math.random()*100 + "-a"} idB={author.toLowerCase() + Math.random()*100 + "-b"}/>
          }
        </div>
      )
    }

    }
  />
);

UserIcon.propTypes = {
  author: PropTypes.string.isRequired,
  emoji: PropTypes.string
};

export default UserIcon;